<template>
<div class="main my">
  <!-- 场馆配置页 -->
  <form class="clear bcw" @submit.prevent="checkForm" v-cloak>
    <div class="clear ptm pbm ml15 prn">
      <div class="left fs2" style="margin-top:.4rem">俱乐部标志</div>
      <div class="right tac" style="width:1.2rem;">
        <upload-file
          :id="'logo'"
          :img="postForm.logo"
          @callBackImgUrl="getIdCardUrl"></upload-file>
      </div>
    </div>
    <van-cell-group>
      <van-field v-model="postForm.scale" label="场馆规模" clearable placeholder="请输入" />
      <van-field v-model="postForm.tableNum" label="球台数" clearable type="number" placeholder="请输入" />      
      <van-cell v-model="clubTimeTips" title="营业时间" @click="timePopupShow = true" is-link />
      <van-field
        label="俱乐部介绍"
        v-model="postForm.desc"
        placeholder="请输入"
        type="textarea"
        rows="4"
        autosize/>
    </van-cell-group>
    <the-btnbar :loadSta="subSta"></the-btnbar>
  </form>

  <!-- 选择时间弹出层 -->
  <van-popup v-model="timePopupShow" position="bottom">
      <van-datetime-picker
          type="time"
          :max-minute="maxMinute"
          :title="clubTimeTitle"
          @cancel="timePopupShow = false;timeStep = 0"
          @confirm="getTime"/>
  </van-popup>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import router from '@/router';
import TheBtnbar from './components/TheBtnBar';
import UploadFile from '@/components/UploadFile';
import {
  Button,
  Row,
  Col,Toast
} from 'vant';

Vue.use(Button).use(Row).use(Col).use(Toast);

export default {
  components: {
    TheBtnbar,UploadFile
  },
  data() {
    return {
      subSta:false, //提交时 按钮状态
      clubInfo: {}, // 当前俱乐部信息
      postForm:{},

      maxMinute:0,
      clubTimeTips:'请选择',
      clubTimeTitle:'开始营业时间',
      timePopupShow: false,
      timeStep: 0,
      startTime:'',  // 开始营业时间
      endTime:'',  // 开始营业时间
    }
  },
  created(){
    // 获取俱乐部信息
    this.$http.post('club_manage/getInfo').then(res => {
      if (!res.data.code) {
        this.postForm = res.data.value
        // this.postForm.desc = res.data.value.desc.replace(/<[^>]+>/g,"")   //过滤标签
        this.clubTimeTips = res.data.value.businessStartTime+":00-"+res.data.value.businessEndTime+":00";   //展示出来的营业时间
        this.postForm.logo = this.postForm.logo || 'https://www.buole.com/assets/v2/img/buole_icon.jpg';   //展示出来的营业时间
      } else {
        Toast.fail(res.data.message);
      }
    })
  },
  methods: {
    goTo(id){
      this.$router.push({ name: 'venueinfo',params: {clubid: id}})
    },
    getIdCardUrl: function(url){
      // 证件照片
      this.postForm[url.name] = url.url;
    },
    getTime: function(time){
      // 营业时间组件 选择营业时间操作
        if(this.timeStep == 0){
            // 设置开始营业时间
            this.startTime = time;
            this.postForm.businessStartTime = time.substr(0, 2);
            this.timeStep = 1;
            Toast('请继续选择结束营业时间');
            this.clubTimeTitle = '结束营业时间';
        }else{
            // 设置结束营业时间
            this.endTime = time;
            this.postForm.businessEndTime = time.substr(0, 2);
            this.timeStep = 0;
            this.clubTimeTips = this.timeGroup;
            this.clubTimeTitle = '开始营业时间';
            this.timePopupShow = false;
        }
    },
    checkForm: function(){
      console.log(this.postForm)

      let _this = this
      let temp = JSON.parse(JSON.stringify(_this.postForm))
      _this.subSta = true
      // 提交表单
      _this.$http.post('club_manage/edit',temp).then(function(res){
          if(res.data.code == 0){
            Toast.success({                
              message:'编辑成功！',
              duration:1000 
            })
            setTimeout(function(){
              _this.$router.go(-1)
            }, 1000) 
          }else{
            Toast(res.data.message)
            _this.subSta = false
          }
      })
    }
  },
  computed: {
      timeGroup: function(){
        // 营业时间组合展示
          return this.startTime + ' - ' + this.endTime
      }
  },
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/manage/SetClubInfo.vue